import request from '@/request/empiAxios.js'

export function getEmpiUser(data){
    return request({
        url:'/empi_api/patient/mdmreport',
        method: 'post',
        data
    })
}

export function saveEmpiUserInfo(data){
    return request({
        url:'/empi_api/patient/addmdm',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/api/empiApi.js